import React, { useEffect, useState } from 'react';
import { formatBalance } from '../../../helper';
import { formatUnits } from 'viem'; // ✅ Add this import

const StakeTokensStep = ({ formData, setFormData, errors, setErrors, onNext, onBack, rewardToken }) => {
  const [balanceError, setBalanceError] = useState('');

  // console.log(formData, 'rewardTokenrewardToken');

  // ✅ Use formatUnits for accurate numeric value (no commas)
  const readableBalance = rewardToken?.balance
    ? (formatUnits(rewardToken.balance, formData?.selectedToken?.tokenDecimals))
    : 0;

  // ✅ Use formatBalance for display (pretty version)
  const displayBalance = rewardToken?.balance
    ? formatBalance(rewardToken.balance, formData?.selectedToken?.tokenDecimals)
    : '0';

  useEffect(() => {
    const amount = parseFloat(formData.stakingAmount);

    if (formData.stakingAmount === '') {
      setBalanceError('');
      return;
    }

    if (isNaN(amount)) {
      setBalanceError('Please enter a valid number.');
    } else if (amount < 0) {
      setBalanceError('Amount cannot be negative.');
    } else if (amount > readableBalance) {
      setBalanceError('Insufficient balance for this staking amount.');
    } else {
      setBalanceError('');
    }
  }, [formData.stakingAmount, readableBalance]);

  const handleNext = () => {
    if (!balanceError && !errors.stakingAmount) {
      onNext();
    }
  };

  return (
    <>
      <div className="wrappermain">
        <div className="textformobile">
          <div className="parentmbl d-none">
            <div className="parent">
              <h6>Stake Tokens</h6>
              <button>3/4</button>
            </div>
          </div>
        </div>

        <div className="upper">
          <h3>Enter Staking Amount</h3>
          <p>
            Balance:{' '}
            <span>
              {displayBalance} {rewardToken?.symbol || 'OASIS'}
            </span>
          </p>
        </div>

        <div className="maininput">
          <input
            type="text"
            placeholder="0.00"
            value={formData.stakingAmount}
            onChange={(e) => {
              setErrors({});
              setFormData((prev) => ({ ...prev, stakingAmount: e.target.value }))
            }}
            className={balanceError ? 'input-error' : ''}
          />

          <div className="parentssss">
            <p>{rewardToken?.symbol || 'OASIS'}</p>
          </div>

          {(errors.stakingAmount || balanceError) && (
            <p className="error-text">{errors.stakingAmount || balanceError}</p>
          )}
        </div>
      </div>

      <div className="flex-bottom-btn">
        <div className="bottom-btns">
          <button className="backbtnbtn" onClick={onBack}>
            Back
          </button>
          <button
            onClick={handleNext}
            className="continuebtn"
            disabled={!!balanceError}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default StakeTokensStep;
